var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1409_29482)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 28,
    height: 28,
    rx: 6,
    fill: "#886DF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 28,
    height: 28,
    rx: 6,
    fill: "url(#paint0_linear_1409_29482)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 27,
    height: 27,
    rx: 5.5,
    stroke: "url(#paint1_linear_1409_29482)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6879 13.125C20.6879 12.9859 20.7291 12.85 20.8064 12.7344C20.8837 12.6187 20.9935 12.5286 21.122 12.4754C21.2504 12.4222 21.3918 12.4083 21.5282 12.4354C21.6646 12.4625 21.7899 12.5295 21.8882 12.6278C21.9866 12.7261 22.0535 12.8514 22.0806 12.9878C22.1078 13.1242 22.0939 13.2656 22.0406 13.3941C21.9874 13.5226 21.8973 13.6324 21.7817 13.7096C21.666 13.7869 21.5301 13.8281 21.391 13.8281C21.2046 13.8281 21.0257 13.754 20.8938 13.6222C20.762 13.4903 20.6879 13.3115 20.6879 13.125ZM19.9848 11.7187C20.1238 11.7187 20.2598 11.6775 20.3754 11.6003C20.491 11.523 20.5812 11.4132 20.6344 11.2847C20.6876 11.1562 20.7015 11.0148 20.6744 10.8785C20.6473 10.7421 20.5803 10.6168 20.482 10.5184C20.3836 10.4201 20.2583 10.3531 20.122 10.326C19.9856 10.2989 19.8442 10.3128 19.7157 10.366C19.5872 10.4192 19.4774 10.5094 19.4002 10.625C19.3229 10.7406 19.2817 10.8766 19.2817 11.0156C19.2817 11.2021 19.3557 11.3809 19.4876 11.5128C19.6195 11.6447 19.7983 11.7187 19.9848 11.7187ZM21.6641 15C21.5402 14.9898 21.4174 15.0292 21.3226 15.1095C21.2278 15.1898 21.1687 15.3045 21.1584 15.4283C21.0745 16.4083 20.7125 17.3439 20.1149 18.1251C19.5173 18.9062 18.7091 19.5005 17.7852 19.8379C16.8613 20.1753 15.8603 20.2418 14.9 20.0296C13.9396 19.8174 13.0598 19.3353 12.3641 18.6401C11.6684 17.9448 11.1858 17.0653 10.973 16.1051C10.7602 15.1449 10.8261 14.1438 11.1629 13.2197C11.4997 12.2957 12.0934 11.487 12.8742 10.889C13.655 10.2909 14.5904 9.92825 15.5703 9.84375C15.6319 9.83867 15.6918 9.82152 15.7468 9.79327C15.8017 9.76502 15.8505 9.72623 15.8905 9.67911C15.9304 9.63199 15.9607 9.57747 15.9795 9.51865C15.9984 9.45984 16.0055 9.39788 16.0004 9.33633C15.9953 9.27477 15.9782 9.21481 15.9499 9.15989C15.9217 9.10496 15.8829 9.05613 15.8358 9.0162C15.7887 8.97626 15.7341 8.946 15.6753 8.92713C15.6165 8.90827 15.5545 8.90117 15.493 8.90625C14.3352 9.00584 13.2299 9.43403 12.3072 10.1404C11.3845 10.8469 10.6827 11.8021 10.2845 12.8938C9.88624 13.9855 9.80807 15.1682 10.0592 16.3029C10.3103 17.4375 10.8802 18.4768 11.7019 19.2985C12.5236 20.1202 13.5629 20.6901 14.6975 20.9412C15.8322 21.1923 17.0149 21.1142 18.1066 20.7159C19.1983 20.3177 20.1536 19.6159 20.86 18.6932C21.5664 17.7705 21.9946 16.6652 22.0942 15.5074C22.0995 15.4458 22.0925 15.3838 22.0737 15.3249C22.0549 15.266 22.0247 15.2114 21.9847 15.1642C21.9447 15.117 21.8958 15.0783 21.8408 15.0501C21.7858 15.0219 21.7257 15.0049 21.6641 15ZM16.0004 10.7812C16.8348 10.7812 17.6505 11.0287 18.3442 11.4922C19.038 11.9558 19.5787 12.6147 19.898 13.3856C20.2173 14.1564 20.3009 15.0047 20.1381 15.823C19.9753 16.6414 19.5735 17.3931 18.9835 17.9831C18.3935 18.5731 17.6418 18.9749 16.8234 19.1377C16.0051 19.3005 15.1568 19.2169 14.386 18.8976C13.6151 18.5783 12.9562 18.0376 12.4926 17.3438C12.0291 16.65 11.7817 15.8344 11.7817 15C11.7829 13.8815 12.2278 12.8092 13.0187 12.0183C13.8096 11.2274 14.8819 10.7825 16.0004 10.7812ZM15.5317 15C15.5317 15.1243 15.581 15.2435 15.669 15.3315C15.7569 15.4194 15.8761 15.4687 16.0004 15.4687H18.8129C18.9372 15.4687 19.0565 15.4194 19.1444 15.3315C19.2323 15.2435 19.2817 15.1243 19.2817 15C19.2817 14.8757 19.2323 14.7564 19.1444 14.6685C19.0565 14.5806 18.9372 14.5312 18.8129 14.5312H16.4692V12.1875C16.4692 12.0632 16.4198 11.9439 16.3319 11.856C16.244 11.7681 16.1247 11.7187 16.0004 11.7187C15.8761 11.7187 15.7569 11.7681 15.669 11.856C15.581 11.9439 15.5317 12.0632 15.5317 12.1875V15ZM17.8754 10.3125C18.0145 10.3125 18.1504 10.2713 18.266 10.194C18.3817 10.1167 18.4718 10.0069 18.525 9.87845C18.5782 9.74997 18.5922 9.60859 18.565 9.4722C18.5379 9.33581 18.4709 9.21052 18.3726 9.11219C18.2743 9.01385 18.149 8.94689 18.0126 8.91976C17.8762 8.89263 17.7348 8.90655 17.6063 8.95977C17.4779 9.01299 17.368 9.10311 17.2908 9.21874C17.2135 9.33437 17.1723 9.47031 17.1723 9.60937C17.1723 9.79585 17.2464 9.9747 17.3782 10.1066C17.5101 10.2384 17.6889 10.3125 17.8754 10.3125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1409_29482",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1409_29482"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.284122 0 0 0 0 0.00449997 0 0 0 0 0.8955 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1409_29482"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145413 0 0 0 0 0.0684 0 0 0 0 0.3116 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1409_29482",
    result: "effect2_dropShadow_1409_29482"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1409_29482",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1409_29482",
    x1: 16,
    y1: 1,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1409_29482",
    x1: 16,
    y1: 1,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockBtn);
export default __webpack_public_path__ + "static/media/clockBtn.41afccec2229866b184dbf6f273f360b.svg";
export { ForwardRef as ReactComponent };